// import axios from "axios";

// const instance = axios.create({
//   baseURL: "http://localhost:8000",
//   // baseURL: "https://demo.restaurantwala.in",
//   // baseURL: "https://restaurants-quick-qr.onrender.com",
//   withCredentials: true,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// instance.interceptors.response.use(
//   (response) => response,

//   async (error) => {
//     const originalRequest = error.config;

//     // Agar login ya refresh API hai to refresh mat karo
//     if (
//       originalRequest.url.includes("/api/auth/login") ||
//       originalRequest.url.includes("/api/auth/refresh")
//     ) {
//       return Promise.reject(error);
//     }

//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry
//     ) {
//       originalRequest._retry = true;

//       try {
//         // Refresh cookie se naya access token banega
//         await instance.post("/api/auth/refresh");

//         // Original request dobara bhej do
//         return instance(originalRequest);
//       } catch (refreshError) {
//         localStorage.clear();

//         if (window.location.pathname !== "/login") {
//           window.location.href = "/login";
//         }

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default instance;

import axios from "axios";

// 🔥 Anonymous ID helper (inline, taaki import cycle na bane)
const STORAGE_KEY = "rw_anonymous_id";
const COOKIE_KEY = "rw_anon";

// const getOrCreateAnonymousId = () => {
//   if (typeof window === "undefined") return null;

//   let id = localStorage.getItem(STORAGE_KEY);

//   // Cookie backup
//   if (!id) {
//     const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
//     if (match) id = match[1];
//   }

//   // Naya banao
//   if (!id || id.length < 16) {
//     id =
//       typeof crypto !== "undefined" && crypto.randomUUID
//         ? crypto.randomUUID().replace(/-/g, "")
//         : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

//     localStorage.setItem(STORAGE_KEY, id);
//     document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
//   }

//   return id;
// };

const getOrCreateAnonymousId = () => {
  if (typeof window === "undefined") return null;

  // 🔥 COOKIE PEHLE CHECK KARO (backend ka authoritative source)
  let id = null;
  const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
  if (match) id = match[1];

  // 🔥 Agar cookie me hai, to localStorage sync karo
  if (id) {
    const lsId = localStorage.getItem(STORAGE_KEY);
    if (lsId !== id) {
      // localStorage ko cookie ke saath sync karo
      localStorage.setItem(STORAGE_KEY, id);
      console.log("🔄 localStorage synced with cookie:", id);
    }
    return id;
  }

  // 🔥 Cookie nahi hai — localStorage check karo
  id = localStorage.getItem(STORAGE_KEY);

  // 🔥 localStorage bhi nahi hai — naya banao
  if (!id || id.length < 16) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, "")
        : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

    localStorage.setItem(STORAGE_KEY, id);
    document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
  }

  return id;
};
const instance = axios.create({
  // baseURL: "http://localhost:8000",
    baseURL:  "https://www.restaurantwala.in",
  // baseURL: "https://demo.restaurantwala.in",
  // baseURL: "https://restaurants-quick-qr.onrender.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// ============================================
// 🔥 REQUEST INTERCEPTOR — anonymousId bhejo
// ============================================
instance.interceptors.request.use((config) => {
  const anonId = getOrCreateAnonymousId();

  if (anonId) {
    config.headers["x-anon-id"] = anonId;

    // POST/PUT/PATCH/DELETE me body ke saath bhi bhejo
    if (
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      config.data.anonymousId = anonId;
    }
  }

  return config;
});

// ============================================
// RESPONSE INTERCEPTOR — 401 refresh (existing)
// ============================================
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      originalRequest.url.includes("/api/auth/login") ||
      originalRequest.url.includes("/api/auth/refresh")
    ) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      // 🔥 Public routes ke liye 401 pe redirect NA karo
  const isPublicRoute =
    originalRequest.url.includes("/my-orders") ||
    originalRequest.url.includes("/orders/whatsapp");

  if (isPublicRoute) {
    return Promise.reject(error); // Sirf error return karo
  }
      originalRequest._retry = true;

      try {
        await instance.post("/api/auth/refresh");
        return instance(originalRequest);
      // } catch (refreshError) {
      //   localStorage.clear();
      //   if (window.location.pathname !== "/login") {
      //     window.location.href = "/login";
      //   }
      //   return Promise.reject(refreshError);
      // }
      } catch (refreshError) {
        localStorage.clear();
        // 🔥 Delivery boy ko delivery login par bhejo:
        if (window.location.pathname.startsWith("/delivery")) {
          if (window.location.pathname !== "/delivery/login") {
            window.location.href = "/delivery/login";
          }
        } else if (window.location.pathname.startsWith("/admin")) {
          if (window.location.pathname !== "/admin/login") {
            window.location.href = "/admin/login";
          }
        } else {
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;